<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Compose Message
          </h3>
          <div class="mt-2"></div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4">
        <div>
          <label
            for="phoneNumber"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Phone Number
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <input
              class="focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
              :class="{
                'bg-gray-200 cursor-not-allowed': !!phoneNumber,
                'bg-white': !phoneNumber
              }"
              type="text"
              v-model="phoneNumber"
              ref="phoneNumber"
              :disabled="!!phoneNumber"
              placeholder="Enter phone number"
            />
          </div>
        </div>
        <div class="mt-4">
          <label
            for="defaultMessage"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Default Message
          </label>
          <p
            class="bg-gray-100 border border-gray-300 rounded-md py-2 px-4 block w-full"
          >
            {{ defaultText }}
          </p>
        </div>
        <div class="mt-4">
          <label
            for="userMessage"
            class="block text-sm font-medium leading-5 text-gray-700"
          >
            Additional Message
          </label>
          <div class="mt-1 relative rounded-md shadow-sm">
            <div class="relative">
              <textarea
                style="min-height: 120px;"
                ref="userMessage"
                v-model="userMessage"
                :maxlength="1024 - defaultText.length"
                class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
                :class="{
                  'border-red-500':
                    userMessage.length + defaultText.length > 1024
                }"
              />
              <div
                class="absolute bottom-2 right-2 text-sm"
                :class="{
                  'text-red-500':
                    userMessage.length + defaultText.length > 1024,
                  'text-gray-500':
                    userMessage.length + defaultText.length <= 1024
                }"
              >
                {{ userMessage.length + defaultText.length }}/1024
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            class="Polaris-Button Polaris-Button--primary"
            type="button"
            @click="onSend"
          >
            <span class="Polaris-Button__Content">
              <span class="Polaris-Button__Text">Send</span>
            </span>
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="close"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    phoneNumber: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      userMessage: "",
      defaultText: ""
    };
  },
  created() {
    const config = this.$store.getters["Inbox/getInboxStarterConfig"];
    if (config && config.template) {
      this.defaultText = config.template.message;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSend() {
      if ((this.userMessage + this.defaultText).length > 1024) {
        alert(
          "Message length exceeds 1024 characters limit. Please shorten your message."
        );
        return;
      }

      this.$emit("send", {
        phoneNumber: this.phoneNumber,
        messageBody: this.userMessage
      });
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped></style>
